import { sendablePlacementPositions } from '../facebook/audience/TargetingSpec/PlatformPlacements';

// Derived from the canonical placement table so the picker and the targeting spec cannot drift.
export const publisherPlatforms =
  sendablePlacementPositions.publisher_platforms;
export type PublisherPlatform = typeof publisherPlatforms[number];
